import {
    CITIES_INFO_SUCCESS,
    FlightRequestActionTypes,
    CREATE_FLIGHT_REQUEST_SUCCESS,
    CityListState,
    FlightTypeListState,
    FLIGHT_TYPES_INFO_SUCCESS,
    CONFIRM_MONITORING_NUMBER_SUCCESS,
    ConfirmMonitoringListState,
    CONFIRM_MONITORING_NUMBER_FAILURE,
    CREATE_FLIGHT_REQUEST_FAILURE,
    CREATE_FLIGHT_REQUEST_CLEAR,
    REVIEW_FLIGHT_REQUEST_SUCCESS,
    REVIEW_FLIGHT_REQUEST_CLEAR,
    REVIEW_FLIGHT_REQUEST_FAILURE,
    CONFIRM_MONITORING_NUMBER_CLEAR,
    GET_FLIGHT_INFO_SUCCESS,
    GET_FLIGHT_INFO_FAILURE,
    GET_FLIGHT_INFO_CLEAR,
    SET_ACCORDION
} from './types';

export function flightInfo(state = [], action: FlightRequestActionTypes) {
    switch (action.type) {
        case GET_FLIGHT_INFO_SUCCESS:
            return action.payload.data.flightInfo;
        case GET_FLIGHT_INFO_FAILURE:
            return { failed: true, refrence: action.requestPayload.data.referenceCode, number: action.requestPayload.data.number };
        case GET_FLIGHT_INFO_CLEAR:
            return action.payload.data.flightInfo;
        default:
            return state;
    }
}

const cityInitialState: CityListState = {
    data: [],
    total: 0,
};
export function cityList(state = cityInitialState, action: FlightRequestActionTypes) {
    switch (action.type) {
        case CITIES_INFO_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

const flightTypesInitialState: FlightTypeListState = {
    data: [],
    total: 0,
};
export function flightTypesList(state = flightTypesInitialState, action: FlightRequestActionTypes) {
    switch (action.type) {
        case FLIGHT_TYPES_INFO_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export const confirmMonitoringInitialState: ConfirmMonitoringListState = {
    data: { instanceId: '', taskId: '', monitoringNumberFile: "" },
};
export function confirmMonitoringNumber(state = confirmMonitoringInitialState, action: FlightRequestActionTypes) {
    switch (action.type) {
        case CONFIRM_MONITORING_NUMBER_SUCCESS:
            return action.payload;
        case CONFIRM_MONITORING_NUMBER_FAILURE:
            return action.payload;
        case CONFIRM_MONITORING_NUMBER_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function createFlightRequest(state = [], action: FlightRequestActionTypes) {
    switch (action.type) {
        case CREATE_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case CREATE_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case CREATE_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function reviewFlightRequestResult(state = {}, action: FlightRequestActionTypes) {
    switch (action.type) {
        case REVIEW_FLIGHT_REQUEST_SUCCESS:
            return action.payload.data;
        case REVIEW_FLIGHT_REQUEST_FAILURE:
            return action.payload.data;
        case REVIEW_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

const initialExpandedAccordion = -1;
export function expandedAccordion(state = initialExpandedAccordion, action: any) {
    switch (action.type) {
        case SET_ACCORDION:
            return action.payload.data;
        default:
            return state;
    }
}